module.exports = __webpack_public_path__ + "7c10d7aed8cbe8c68a7f89dd2cb0369a.svg";